import { createRouter, createWebHashHistory } from "vue-router";
import { isAuthenticated } from "../services/auth";
import HomeComponent from "../components/HomeComponent.vue";
import ChangeAuth0Email from "../components/ChangeAuth0Email.vue";
import ChangeAuth0AssociatedMembership from "../components/ChangeAuth0AssociatedMembership.vue";
import UpdateVirtualMembershipCard from "../components/UpdateVirtualMembershipCard.vue";
import ResendOTPCode from "../components/ResendOTPCode.vue";
import LoginView from "../views/LoginView.vue";

// Hash history so navigation never depends on server-side SPA fallback
// (the app is currently served by the webpack dev server; this keeps deep
// links / refreshes working regardless of how dist is hosted).
const routes = [
  { path: "/login", name: "login", component: LoginView, meta: { public: true, title: "Sign In" } },
  { path: "/", name: "home", component: HomeComponent, meta: { title: "Home" } },
  { path: "/change-email", name: "change-email", component: ChangeAuth0Email, meta: { title: "Change Login Email" } },
  {
    path: "/change-membership",
    name: "change-membership",
    component: ChangeAuth0AssociatedMembership,
    meta: { title: "Change Membership #" },
  },
  {
    path: "/update-card",
    name: "update-card",
    component: UpdateVirtualMembershipCard,
    meta: { title: "Update Virtual Membership Card" },
  },
  { path: "/resend-code", name: "resend-code", component: ResendOTPCode, meta: { title: "Resend Login Code" } },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

// Auth gate: unauthenticated users can only reach public routes; authenticated
// users are bounced off the login page.
router.beforeEach((to) => {
  if (!to.meta.public && !isAuthenticated()) {
    return { name: "login" };
  }
  if (to.name === "login" && isAuthenticated()) {
    return { name: "home" };
  }
  return true;
});

router.afterEach((to) => {
  document.title = to.meta.title
    ? `${to.meta.title} — CC Auth0 Helper`
    : "CC Auth0 Helper App";
});

export default router;
